import React from "react";
import {
  ResponsiveContainer, LineChart, Line, BarChart, Bar, XAxis, YAxis, Tooltip, Legend,
  CartesianGrid, PieChart, Pie, Cell,
} from "recharts";
import { inr, periodLabel } from "./iaUtils";

const COLORS = { wallet: "#2D5A27", razorpay: "#2563EB", upi: "#D97706", cash: "#7A2E18", card: "#6D28D9", manual: "#8A8780", bank_transfer: "#0E7490" };

function Panel({ title, children, testid }) {
  return (
    <div className="bg-white border border-[#E5E2D9] rounded-md p-3" data-testid={testid}>
      <div className="text-xs font-semibold text-[#1A1A1A] mb-2">{title}</div>
      <div className="h-56">{children}</div>
    </div>
  );
}

const axis = { fontSize: 10, fill: "#8A8780" };

export function TrendCharts({ periods, split, group }) {
  const data = periods.map(p => ({ ...p, label: periodLabel(p.period, group) }));
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-3" id="ia-charts" data-testid="ia-charts">
      <Panel title="SRs created vs completed" testid="ia-chart-srs">
        <ResponsiveContainer><LineChart data={data}>
          <CartesianGrid stroke="#F0EDE4"/><XAxis dataKey="label" tick={axis}/><YAxis tick={axis} allowDecimals={false}/>
          <Tooltip/><Legend wrapperStyle={{ fontSize: 11 }}/>
          <Line type="monotone" dataKey="sr_created" name="Created" stroke="#1A1A1A" strokeWidth={2} dot={false}/>
          <Line type="monotone" dataKey="sr_completed" name="Completed" stroke="#2D5A27" strokeWidth={2} dot={false}/>
        </LineChart></ResponsiveContainer>
      </Panel>
      <Panel title="Invoices generated vs paid (₹)" testid="ia-chart-invoices">
        <ResponsiveContainer><BarChart data={data}>
          <CartesianGrid stroke="#F0EDE4"/><XAxis dataKey="label" tick={axis}/><YAxis tick={axis}/>
          <Tooltip formatter={(v) => inr(v)}/><Legend wrapperStyle={{ fontSize: 11 }}/>
          <Bar dataKey="inv_generated_amt" name="Generated ₹" fill="#D4A017"/>
          <Bar dataKey="inv_paid_amt" name="Paid ₹" fill="#2D5A27"/>
        </BarChart></ResponsiveContainer>
      </Panel>
      <Panel title="Collected vs outstanding (₹)" testid="ia-chart-collected">
        <ResponsiveContainer><BarChart data={data}>
          <CartesianGrid stroke="#F0EDE4"/><XAxis dataKey="label" tick={axis}/><YAxis tick={axis}/>
          <Tooltip formatter={(v) => inr(v)}/><Legend wrapperStyle={{ fontSize: 11 }}/>
          <Bar dataKey="collected" name="Collected" stackId="a" fill="#2D5A27"/>
          <Bar dataKey="outstanding" name="Outstanding" stackId="a" fill="#B42828"/>
        </BarChart></ResponsiveContainer>
      </Panel>
      <Panel title="Payment source split" testid="ia-chart-sources">
        {split.length === 0 ? <div className="h-full grid place-items-center text-xs text-[#8A8780]">No payments in range</div> : (
          <ResponsiveContainer><PieChart>
            <Pie data={split} dataKey="amount" nameKey="source" innerRadius={50} outerRadius={80} paddingAngle={2}>
              {split.map(s => <Cell key={s.source} fill={COLORS[s.source] || "#8A8780"}/>)}
            </Pie>
            <Tooltip formatter={(v) => inr(v)}/><Legend wrapperStyle={{ fontSize: 11 }}/>
          </PieChart></ResponsiveContainer>
        )}
      </Panel>
    </div>
  );
}
